import Page from "webPage/Page";

export default function handleNewsFilter() {
    let $newsFilter = $('.js-news-filter');

    const query = Page.get_query();
    const searchTerm = query.search;
    const paged = typeof query.pd !== 'undefined' ? query.pd : 1;
    const category = query.category;

    if (category) {
        $('.js-blog-category-select').val(category);
    }

    if (searchTerm) {
        $('.js-search-term, .js-search-term-text').text(searchTerm);
        performSearch({
            search: searchTerm,
            category: category,
            paged: paged,
        });
    }

    if ($newsFilter.length > 0) {
        $('.js-blog-category-select').on('change', function () {
            if ($(this).val() !== '') {
                window.location = '/category/' + $(this).val();
            }
        });

        $('.js-blog-year-select').on('change', function () {
            window.location = $(this).val();
        });

        $('body').on('submit', '.js-search-posts', function () {
            let $searchField = $('.js-search-field');

            if ($searchField.val() === '') {
                return false;
            }
        });
    }
}

async function performSearch(query) {
    const $results = $(".js-search-results");

    $results.addClass('loading');

    try {
        const result = await getSearchResults(query);

        if (!result.success || !result.data.html) {
            $results.removeClass('loading');
            $results.html(
                eotwJSXFactory('div', {className: "columns__item columns__item--3-full"}, [
                    eotwJSXFactory('div', {className: "no-result"}, [
                        eotwJSXFactory('p', null, ["No results found for search, please try again."])
                    ])
                ]),
            );
            return;
        }

        $results.removeClass('loading');
        $results.html(result.data.html);
    } catch (e) {
        console.warn(e);
        $results.removeClass('loading');
        $results.html(
            eotwJSXFactory('p', null, ["Sorry, there was a problem getting your search results. Please try again later"]),
        );
    }
}

async function getSearchResults(query) {
    return Ajax.get('eotw', 'search', query);
}
